module.exports = __webpack_public_path__ + "img/asanka-pro.5fad9be4.jpg";